"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var utils_1 = require("./utils");
var FieldSection = /** @class */ (function () {
    function FieldSection(name) {
        this.attachCount = 1;
        this.subFields = new Map();
        this.update(name);
    }
    FieldSection.prototype.update = function (name) {
        this.name = name;
    };
    Object.defineProperty(FieldSection.prototype, "attached", {
        get: function () {
            return this.attachCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    FieldSection.prototype.addField = function (field) {
        // todo: looks like this is not a good solution to copy this part of code fron FieldArray
        var fieldPath = utils_1.objectPath(field.name);
        var lastPathNode = fieldPath[fieldPath.length - 1];
        this.subFields.set(lastPathNode, field);
    };
    // todo: probably we dont need values()
    FieldSection.prototype.reset = function () {
        this.subFields.forEach(function (subField) { return subField.reset(); });
    };
    FieldSection.prototype.setTouched = function () {
        this.subFields.forEach(function (subField) { return subField.setTouched(); });
    };
    FieldSection.prototype.removeField = function (index) {
        this.subFields.delete(index);
    };
    FieldSection.prototype.getField = function (index) {
        return this.subFields.get(index);
    };
    FieldSection.prototype.detach = function () {
        if (this.attached) {
            this.attachCount = this.attachCount - 1;
        }
        this.subFields.forEach(function (subField) { return subField.detach(); });
    };
    Object.defineProperty(FieldSection.prototype, "value", {
        get: function () {
            // tslint:disable-next-line: max-line-length
            return Array.from(this.subFields.entries()).reduce(function (values, _a) {
                var name = _a[0], field = _a[1];
                if (field.attached) {
                    values[name] = field.value;
                }
                return values;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldSection.prototype, "rules", {
        get: function () {
            // tslint:disable-next-line: max-line-length
            return Array.from(this.subFields.values()).reduce(function (rules, field) {
                if (!field.attached) {
                    Object.assign(rules, field.rules);
                }
                return rules;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldSection.prototype, "isDirty", {
        get: function () {
            // tslint:disable-next-line: max-line-length
            return Array.from(this.subFields.values()).some(function (subField) { return subField.isDirty; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], FieldSection.prototype, "attachCount", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], FieldSection.prototype, "subFields", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], FieldSection.prototype, "attached", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FieldSection.prototype, "addField", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FieldSection.prototype, "reset", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FieldSection.prototype, "setTouched", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], FieldSection.prototype, "removeField", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FieldSection.prototype, "value", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FieldSection.prototype, "rules", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FieldSection.prototype, "isDirty", null);
    return FieldSection;
}());
exports.FieldSection = FieldSection;
//# sourceMappingURL=FieldSection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/FieldSection.js
// module id = 130
// module chunks = 0